import { CategoryDropdownRoot } from './CategoryDropdown';
import { CategoryDropdownTrigger } from './CategoryDropdownTrigger';

export const CategoryDropdown = Object.assign(CategoryDropdownRoot, {
  Trigger: CategoryDropdownTrigger,
});

export { HeaderCategoryTrigger } from './HeaderCategoryTrigger';
export { useCategoryDropdown } from './CategoryDropdownContext';
export type { UseCategoryDropdownResult } from './CategoryDropdownContext';
export type { CategoryDropdownProps } from './types';
export type { CategoryDropdownTriggerProps } from './CategoryDropdownTrigger';
export type { HeaderCategoryTriggerProps } from './HeaderCategoryTrigger';
